// ----- IMPORTS -----
import DOMPurify from 'dompurify';

// ----- CONSTANTES -----
window.DOMPurify = DOMPurify;
window.TIME_CACHE_SEAT_MAP_BLOCK = 20000;
window.FIDELIZACION_OPERACION_REDIMIR = "R";
window.FIDELIZACION_OPERACION_ACUMULAR = "A";
window.FIDELIZACION_OPERACION_CADUCAR = "C";
window.FIDELIZACION_OPERACION_CODIGO_DESCUENTO = "D";
window.FIDELIZACION_TIPO_TARJETA_FIDELIZACION = "F";
window.FIDELIZACION_TIPO_TARJETA_CODIGO_DESCUENTO = "D";
window.LOYALTY_CARD_TYPE_GIFT_CARD = "G";

window.MAX_ID_SYSTEM_PROFILES = 1;

window.lastNotifType = "";

window.anchoColumnaAccion = "2rem";

//==================================== Configuración de taquilla =========================================

window.PARAMETRO_CONFIGURACION_ID_EMPRESA_TAQUILLA = "idEmpresaTaq";
window.PARAMETRO_CONFIGURACION_ID_CANAL_TAQUILLA = "idCanalTaq";
window.PARAMETRO_CONFIGURACION_TIPO_PAPEL_ENTRADAS_ID = "tipo_papel_entradas_id";
window.PARAMETRO_CONFIGURACION_TIPO_PAPEL_RECIBOS_ID = "tipo_papel_recibos_id";
window.PARAMETRO_CONFIGURACION_IMPRESION_AUTOMATICA_ENTRADAS = "impresion_automatica_entradas";
window.PARAMETRO_CONFIGURACION_IMPRESION_AUTOMATICA_RECIBOS = "impresion_automatica_recibos";
window.PARAMETRO_CONFIGURACION_MOSTRAR_HISTORIAL_VENTAS = "mostrar_historial_ventas";
window.PARAMETRO_CONFIGURACION_POINT_DEVICE_ID = "point_device_id";


/**
 * Tipos de recinto
 */
window.VENUE_TYPE =
{
	"NORMAL": 0,
	"ONLINE": 1,
	"SPECIAL_PRODUCTS": 2
}

window.VIRTUAL_QUEUE_STATUS =
{
	"INACTIVE": 0,
	"ACTIVE": 1,
	"PREQUEUE": 2,
	"QUEUE": 3,
	"FINISHED": 4,
}

window.DROPBOX_IMAGE_STATUS =
{
	"EVENT_LEVEL": 0,
	"VENUE_LEVEL": 1,
	"COMPANY_LEVEL": 2,
	"CANT_DELETE": 3,
	"DELETE_ON_EVENT": 4,
	"DELETE_ON_VENUE": 5,
	"DELETE_ON_COMPANY": 6,
	"DELETED": 7,
	"IMAGE_NOT_FOUND": 8,
	"CANT_DELETE_DEFAULT_IMAGE": 9,
	"ZONE_LEVEL": 10,
	"PRODUCTS_LEVEL": 11,
	"SITES_LEVEL": 12,
	"ACCREDITATION_TYPE_LEVEL": 13
}
/**
 * Tipos de empresa
 */
window.CompanyTypes =
{
	"Default": 0,
	"Propietario": 1,
	"Canal": 2,
	"Promotor": 3,
	"Administracion": 4
}

/**
 * Canales
 */
window.ChannelsDefault =
{
	"Boxoffice": 1
}

/**
 * Perfiles de los usuarios
 */
window.Perfiles =
{
	"NoAutenticado": 0,
	"Comprador": 1,
	"Taquilla": 2,
	"Gerente": 3,
	"CallCenter": 4,
	"Agencia": 5,
	"InformesPromotor": 6,
	"ATCPromotor": 7,
	"ATCCanal": 8,
	"InformesCanal": 10,
	"VendedorExterno": 11,
	"ContenidoMarketing": 12,
    "Kiosko": 13,
	"Administrador": 9
};


/**
 * Estados de pago
 */
window.EstadosPago =
{
	"IniciandoPago": 0,
	"PagoOK": 1,
	"PagoKO": 2,
	"PagoTimeout": 3,
	"PagoPendiente": 4,
	"PagoPendienteRedireccion": 5,
	"PagoPendienteConfirmacion": 6,
	"PagoParcialAutorizado": 7,
	"PagoEnTiendaPendiente": 8,
	"PagoPendienteCuota": 9,
	"IniciandoAnulacion": 10,
	"AnulacionOK": 11,
	"AnulacionKO": 12,
	"AnulacionTimeout": 13,
	"AnulacionNoRealizada": 14,
	"CancelledPayment": 16,
	"AuthenticacionCompradorFinalizada": 101,
	"AuthenticacionPSD2Comprador": 102,
	"NecesitaDatosExtra": 103
};

/**
 * Formas de pago
 */
window.FormasPago =
{
	"Efectivo": 1,
	"Datafono": 2,
	"PinPadBanorte": 3,
	"Transferencia": 4,
	"Puntos": 5,
	"Cupon": 6,
	"TarjetaRedsys": 7,
	"Paypal": 8,
	"Fidelizacion": 9,
	"TarjetaBanorte": 10,
	"TarjetaDummy": 11,
	"PinPadRedsys": 12,
	"PinPadDummy": 13,
	"TiendaOpenpayPaynet": 14,
	"PinpadElavon": 16,
	"TarjetaAllegra": 19,
	"Otros": 21,
	"Refund": 22,
	"PinpadAdyen": 32,
	"ECI": 33,
	"PinpadHSBC": 34,
	"OpenpayTarjeta": 35,
	"AdyenV41Version": 36,
	"AuthorizedNet": 37,
	'GiftCard': 38,
	"Stripe": 39,
	"CardConnect": 40,
	"Bancomer": 42,
	"VisaNetWeb": 45,
	"Payphone": 46,
	"VisaNetButton": 47,
	"PixelPay": 48,
	"Cybersource": 58,
	"PayphoneExpress": 49,
	"AthMovilButton": 50,
	"PagandoCheck": 51,
	"MercadoPagoV2": 52,
	"MercadoPagoV2Efecty": 53,
	"MercadoPagoV2PSE": 54,
	"MercadoPagoV2Wallet": 79,
	"PayU": 55,
	"TicketPagoTuEnlace": 56,
	"Fiserv": 62,
	"Bancard": 67,
	"Aplazo": 69,
	"Uepapay": 70,
	"PaypalV2": 71,
	"Deferred": 72,
	"Recurrente": 76,
	"Line": 78,
	"MercadoPagoPoint": 80,
	"Powertranz": 82,
	"Deuna": 83,
	"InstapagoQR": 84,
	"Modo": 85,
	"dLocal": 86,
	"EvoPayments": 87,
	"Nave": 88,
	"Conekta": 89
};

window.PaymentMethodAllowedCountries = {
	"Stripe": [
	  'AE', 'AT', 'AU', 'BE', 'BG', 'BR', 'CA', 'CH', 'CI', 'CR', 'CY', 'CZ', 'DE', 'DK',
	  'DO', 'EE', 'ES', 'FI', 'FR', 'GB', 'GI', 'GR', 'GT', 'HK', 'HR', 'HU', 'ID', 'IE',
	  'IN', 'IT', 'JP', 'LI', 'LT', 'LU', 'LV', 'MT', 'MX', 'MY', 'NL', 'NO', 'NZ', 'PE',
	  'PH', 'PL', 'PT', 'RO', 'SE', 'SG', 'SI', 'SK', 'SN', 'TH', 'TT', 'US', 'UY'
	],
	"Openpay": ['MX', 'PE']
};
window.OrganizationIntegrationTypes =
{
	"MailChimp": 10,
	"ZigPay": 12
};

/**
 * Estados de detalle venta
 */
window.Estados =
{
	'Libre': -1,
	'Pagado': 0,
	'Reserva': 1,
	'Bloqueo': 2,
	'BloqueoAbono': 3,
	'BloqueoCovid': 4,
	'Anulado': 10,
	'ReservaCancelada': 11,
	'BloqueoCancelado': 12,
	'Anulacion': 50,
	'CancelacionReserva': 51,
	'CancelacionBloqueo': 52,
	'ReservaInternet': 100,
	'PagoRechazado': 101,
	'Paquete': 102
};

/**
 * Tipos de evento
 */
window.EventTypes =
{
	'Normal': 0,
	'AbonoTemporada': 1,
	'AbonoALaCarta': 2,
	'ContenedorGira': 3,
	'ContenedorCombinado': 4,
	'Accreditation': 5,
	'Streaming': 6,
	'Multipass': 7,
	'FanID': 8,
	'GiftCard': 9,
	"FakeEvent": 10,
	"AccreditationPass": 11,
	"AccreditationPassEvent": 12,
};


/**
 * Tipos de butaca
 */
window.TiposButaca =
{
	"Normal": 1,
	"Discapacitado": 2,
	"Eliminada": 3
};

/**
 * Tipo de operaciones de venta
 */
window.TipoOperacionVenta =
{
	"VentaRegular": 1,
	"VentaMovida": 2,
	"BoxOfficeUntilDateBooking": 3,
	"BoxOfficeTemporalBooking": 4
};

/**
 * Hall types
 */
window.HallTypes =
{
	'Physical': 0,
	'Streaming': 1,
	'FanID': 2,
	'Accreditation': 4
};

/**
	Zone view types
 */
window.ZoneViewTypes =
{
	"None": 0,
	"Plain": 1,
	"Panoramic": 2,
	"Cube": 3,
	"Spherical": 4
}

/**
 * Modo de mostrar los planos de una sala.
 */
window.PlanoModoZonas =
{
	"NoNumerado": -1,
	"Sala": 0,
	"GrupoZonas": 1,
	"Zonas": 2
};

window.IdCardType =
{
	"NOT_DEFINED": 0,
	"RUT_CL": 1,
	"DNI_ES": 2,
	"CPF_BR": 3,
	"CNPJ_BR": 4,
	"PASSPORT": 5,
	"NIE_ES": 6,
	"CIF_ES": 7,
	"DNI_PE": 8,
	"RUC_PE": 9,
	"INE_MX": 10,
	"RFC_MX": 11,
	"PESEL_PL": 12,
	"DNI_AR": 13,
	"CUIL_AR": 14,
	"CUIT_AR": 15,
	"RNC_DO": 16,
	"CEDULA_DO": 17,
	"NIT_GT": 18,
	"CUI_GT": 19,
	"DNI_CL": 20,
	"CEDULA_PY": 21,
	"NIT_CO": 22,
	"CEDULACIUDADANIA_CO": 23,
	"TARJETAIDENTIDAD_CO": 24,
	"CEDULAEXTRANJERIA_CO": 25,
	"PA_CEDULA": 26,
	"EC_CEDULA": 27,
	"PE_CEDULA": 28,
	"PE_RIF": 29,
	"VE_CEDULA": 30,
	"VE_RIF": 31,
	"BR_CEDULA": 32,
	"PY_RUC": 33,
	"EC_RUC": 34,
	"PA_RUC": 35,
	"SV_DUI": 36,
	"SV_NIT": 37,
	"PR_REALID": 38,
	"PR_TI": 39,
	"BO_CEDULA": 40,
	"BO_NIT": 41,
	"CR_CEDULA": 42,
	"CR_NITE": 43,
	"NI_CEDULA": 44,
	"NI_RUC": 45,
	"UY_CEDULA": 46,
	"UY_RUT": 47,
	"UY_NIE": 48
};

window.ProductType =
{
	"TICKET": 1,
	"PRODUCT": 2,
	"BUNDLE": 3,
	"MULTIPASS": 4,
	"DONATION": 5,
	"FEE": 6,
	"INSURANCE": 7,
	"FANID": 8,
	"GIFTCARD": 9,
	"SHIPPING": 10,
	"ACCREDITATION": 11
};

window.ProductTypePriceTDflt =
{
	1: 1,
	2: 21,
	3: 30,
	4: 40,
	5: 50,
	6: 60,
	7: 70,
	10: 74
};

/**
 * Price type
 */
window.PriceType =
{
	"General": 1,
	"Reducido": 2,
	"Invitacion": 3,
	"Oferta": 4,
	"CodigoDescuento": 5,
	"Grupos": 6,
	"Fidelizacion": 7,
	"Promo": 8,
	"SesionAbono": 9,
	"HardTicketing": 10,

	"ProdGeneral": 11,
	"ProdInvitacion": 12,
	"ProdOferta": 13,
	"ProdCodDescuento": 14,
	"ProdFidelizacion": 15,
	"ProdLoyalty": 25,
	"RecargaAbono": 26,
	"IncludedWithTicket": 29,
    "DependencyTicket": 31,

	"Donation": 50,
	"DonationOpenAmount": 51,

	"FeeTransaction": 60,
	"FeePaymentMethod": 61,

	"Insurance": 70,
	"InsuranceProtectGroup": 71,
	"InsuranceProtecht": 72,
	"InsuranceReale": 74,
	"InsurancePlanout": 75,

	"GiftCards": 73,

	"DomesticShipping": 100,
	"InternationalShipping": 101

	//	,
	//	"FeeDelivery": 62
};


/**
 * Tag types
 */
window.TagType =
{
	"EVENT_DISPLAY": 1,
	"EVENT_CATEGORY": 2,
	"EVENT_AUTO": 3,
	"EVENT_CUSTOM": 4,

	"CUSTOMER_AUTO": 11,
	"CUSTOMER_MANUAL": 12
};

window.TagTypeCustomersList = 105;

/**
 * Promotion types
 */
window.PromotionType =
{
	"SPECIAL_PRICE_PROMOTION": 0,
	"LOYALTY_CLUB": 1,
	"PRIORITY_ACCESS_PROMOTION": 2,
	"PROMOTION": 3,
	"GIFT_CARDS": 4,
	"INVITATION": 5
};

/**
 * PriceTable types
 */
window.PricetableType =
{
	TICKETS: 1,
	PRODUCTS: 2,
	SPECIAL_PRODUCTS: 3
};

/**
 * Black/White list types
 */
window.ListType =
{
	BLACK: 0,
	WHITE: 1
};

/**
 * Billing types
 */
window.InvoicingType =
{
	NO_BILLING: 0,
	MANDATORY_BILLING: 1,
	OPTIONAL_BILLING: 2,
	SELF_BILLING_ORGANIZATION: 3,
	SELF_BILLING_CUSTOMER: 4
};

/**
 * Accreditation reject reasons
 */
window.AccreditationRequestRejectReason =
{
	0: "accreditations.reject_reason.incorrect_app_data",
	1: "accreditations.reject_reason.passport_id_not_legible",
	2: "accreditations.reject_reason.out_of_time",
	3: "accreditations.reject_reason.full_capacity",
	4: "accreditations.reject_reason.poor_image_quality"
};

window.StreamingPlatforms = [
	{ id: "ENETRES", displayName: "Enetres", requiredFields: "url#transmissionStart#transmissionStop", icon: "enetres", integration_type: 2 },
	{ id: "VIMEO", displayName: "Vimeo", requiredFields: "url#showUrl#password#onlyOneSessionByTicket#transmissionStart#transmissionStop#timezone", icon: "vimeo", integration_type: 1 },
	{ id: "ZOOM", displayName: "Zoom", requiredFields: "url#showUrl#id#password#onlyOneSessionByTicket#transmissionStart#transmissionStop#timezone", icon: "zoom", integration_type: 1 },
	{ id: "YOUTUBE", displayName: "YouTube", requiredFields: "url#showUrl#transmissionStart#transmissionStop#timezone", icon: "youtube", integration_type: 1 },
	{ id: "FACEBOOK", displayName: "Facebook", requiredFields: "url#showUrl#onlyOneSessionByTicket#transmissionStart#transmissionStop#timezone", icon: "facebook", integration_type: 1 },
	{ id: "LINKEDIN", displayName: "LinkedIn", requiredFields: "url#showUrl#onlyOneSessionByTicket#transmissionStart#transmissionStop#timezone", icon: "linkedin", integration_type: 0 },
	{ id: "INSTAGRAM", displayName: "Instagram", requiredFields: "url#showUrl#transmissionStart#transmissionStop#timezone", icon: "instagram", integration_type: 0 },
	{ id: "TEAMS", displayName: "Microsoft Teams", requiredFields: "url#showUrl##transmissionStart#transmissionStop#timezone", icon: "microsoft_teams", integration_type: 0 },
	{ id: "MEET", displayName: "Google Meet", requiredFields: "url#showUrl#transmissionStart#transmissionStop#timezone", icon: "meet", integration_type: 0 },
	//{id: "OTHERS", displayName: polyglot.t("activity.events_chart.Others"), requiredFields: "url#showUrl#transmissionStart#transmissionStop", icon:"streaming", integration_type:0},
];

window.StreamingPlatformsIntegrationType =
{
	"EXTERNAL_LINK": 0,
	"IFRAME_IN_SITE": 1,
	"IFRAME_WITH_USER": 2
};

window.NotificationStatus = {
	"IN_PROGRESS_STATUS": 0,
	"ERROR_STATUS": 1,
	"DONE_STATUS": 2,
	"START_STATUS": 3
}

window.NotificationTagsTranslations = {
	"mailing": "notifications.mailing",
	"quotas": "notifications.quotas",
	"sessions": "notifications.sessions",
	"blackWhiteLists": "notifications.blackWhiteLists",
	"accreditations" : "notifications.accreditations",
	"crm": "notifications.crm",
	"reports": "notifications.reports",
	"salesTransfer": "notifications.salesTransfer",
	"promos": "notifications.promos",
	"sms": "SMS",
	"boxoffice" : "notifications.boxoffice"
}

window.SIZE_WINDOW = {
	DESKTOP: 0,
	TABLET: 1,
	MOBILE: 2
};


window.mapTextoBuscar =
{
	'À': 'A',
	'Á': 'A',
	'Â': 'A',
	'Ã': 'A',
	'Ä': 'A',
	'Å': 'A',
	'Æ': 'AE',
	'Ç': 'C',
	'È': 'E',
	'É': 'E',
	'Ê': 'E',
	'Ë': 'E',
	'Ì': 'I',
	'Í': 'I',
	'Î': 'I',
	'Ï': 'I',
	'Ð': 'D',
	'Ñ': 'N',
	'Ò': 'O',
	'Ó': 'O',
	'Ô': 'O',
	'Õ': 'O',
	'Ö': 'O',
	'Ø': 'O',
	'Ù': 'U',
	'Ú': 'U',
	'Û': 'U',
	'Ü': 'U',
	'Ý': 'Y',
	'ß': 's',
	'à': 'a',
	'á': 'a',
	'â': 'a',
	'ã': 'a',
	'ä': 'a',
	'å': 'a',
	'æ': 'ae',
	'ç': 'c',
	'è': 'e',
	'é': 'e',
	'ê': 'e',
	'ë': 'e',
	'ì': 'i',
	'í': 'i',
	'î': 'i',
	'ï': 'i',
	'ñ': 'n',
	'ò': 'o',
	'ó': 'o',
	'ô': 'o',
	'õ': 'o',
	'ö': 'o',
	'ø': 'o',
	'ù': 'u',
	'ú': 'u',
	'û': 'u',
	'ü': 'u',
	'ý': 'y',
	'ÿ': 'y',
	'Ā': 'A',
	'ā': 'a',
	'Ă': 'A',
	'ă': 'a',
	'Ą': 'A',
	'ą': 'a',
	'Ć': 'C',
	'ć': 'c',
	'Ĉ': 'C',
	'ĉ': 'c',
	'Ċ': 'C',
	'ċ': 'c',
	'Č': 'C',
	'č': 'c',
	'Ď': 'D',
	'ď': 'd',
	'Đ': 'D',
	'đ': 'd',
	'Ē': 'E',
	'ē': 'e',
	'Ĕ': 'E',
	'ĕ': 'e',
	'Ė': 'E',
	'ė': 'e',
	'Ę': 'E',
	'ę': 'e',
	'Ě': 'E',
	'ě': 'e',
	'Ĝ': 'G',
	'ĝ': 'g',
	'Ğ': 'G',
	'ğ': 'g',
	'Ġ': 'G',
	'ġ': 'g',
	'Ģ': 'G',
	'ģ': 'g',
	'Ĥ': 'H',
	'ĥ': 'h',
	'Ħ': 'H',
	'ħ': 'h',
	'Ĩ': 'I',
	'ĩ': 'i',
	'Ī': 'I',
	'ī': 'i',
	'Ĭ': 'I',
	'ĭ': 'i',
	'Į': 'I',
	'į': 'i',
	'İ': 'I',
	'ı': 'i',
	'Ĳ': 'IJ',
	'ĳ': 'ij',
	'Ĵ': 'J',
	'ĵ': 'j',
	'Ķ': 'K',
	'ķ': 'k',
	'Ĺ': 'L',
	'ĺ': 'l',
	'Ļ': 'L',
	'ļ': 'l',
	'Ľ': 'L',
	'ľ': 'l',
	'Ŀ': 'L',
	'ŀ': 'l',
	'Ł': 'L',
	'ł': 'l',
	'Ń': 'N',
	'ń': 'n',
	'Ņ': 'N',
	'ņ': 'n',
	'Ň': 'N',
	'ň': 'n',
	'ŉ': 'n',
	'Ō': 'O',
	'ō': 'o',
	'Ŏ': 'O',
	'ŏ': 'o',
	'Ő': 'O',
	'ő': 'o',
	'Œ': 'OE',
	'œ': 'oe',
	'Ŕ': 'R',
	'ŕ': 'r',
	'Ŗ': 'R',
	'ŗ': 'r',
	'Ř': 'R',
	'ř': 'r',
	'Ś': 'S',
	'ś': 's',
	'Ŝ': 'S',
	'ŝ': 's',
	'Ş': 'S',
	'ş': 's',
	'Š': 'S',
	'š': 's',
	'Ţ': 'T',
	'ţ': 't',
	'Ť': 'T',
	'ť': 't',
	'Ŧ': 'T',
	'ŧ': 't',
	'Ũ': 'U',
	'ũ': 'u',
	'Ū': 'U',
	'ū': 'u',
	'Ŭ': 'U',
	'ŭ': 'u',
	'Ů': 'U',
	'ů': 'u',
	'Ű': 'U',
	'ű': 'u',
	'Ų': 'U',
	'ų': 'u',
	'Ŵ': 'W',
	'ŵ': 'w',
	'Ŷ': 'Y',
	'ŷ': 'y',
	'Ÿ': 'Y',
	'Ź': 'Z',
	'ź': 'z',
	'Ż': 'Z',
	'ż': 'z',
	'Ž': 'Z',
	'ž': 'z',
	'ſ': 's',
	'ƒ': 'f',
	'Ơ': 'O',
	'ơ': 'o',
	'Ư': 'U',
	'ư': 'u',
	'Ǎ': 'A',
	'ǎ': 'a',
	'Ǐ': 'I',
	'ǐ': 'i',
	'Ǒ': 'O',
	'ǒ': 'o',
	'Ǔ': 'U',
	'ǔ': 'u',
	'Ǖ': 'U',
	'ǖ': 'u',
	'Ǘ': 'U',
	'ǘ': 'u',
	'Ǚ': 'U',
	'ǚ': 'u',
	'Ǜ': 'U',
	'ǜ': 'u',
	'Ǻ': 'A',
	'ǻ': 'a',
	'Ǽ': 'AE',
	'ǽ': 'ae',
	'Ǿ': 'O',
	'ǿ': 'o'
};

window.CRM_VISUALIZATION_MODE = {
	CUSTOMERS : 1,
	ACCREDITATIONS : 2,
	BOXOFFICE: 3,
	FANID: 4
};

window.CRM_MODE_TAGS = {
	CUSTOMER : 0,
	FILTER : 1,
	MULTIPLE_CUSTOMERS : 2
};

window.CRM_EVENT_TYPES = {
	ACCREDITATION : 5,
	FAN_ID : 8
};

window.STATUS_ACCREDITED = {
	NEW : 0,
	PENDING : 1,
	ACCEPTED : 2,
	REJECTED : 3,
	AUTO_ACCEPTED : 4
};

window.PAGINATION_QUANTITY_PER_REQUEST = {
	"CUSTOMERS": 500,
	"ACCREDITEDS": 500,
	"PROMOTIONS": 500,
	"TRANSACTIONS": 500,
}

window.PAGINATION_TABLE = {
	"CUSTOMERS": "buyers-table",
	"ACCREDITEDS_FAN_ID": "accrediteds-fan-id-details",
	"PROMOTIONS": "promo-code-table",
	"TRANSACTIONS": "last-transactions-body",
}

window.PAGINATION_TABLE_ELEMENT = {
	"CUSTOMERS": "idComprador",
	"ACCREDITEDS_FAN_ID": "idRequest",
	"TRANSACTIONS": "orderId"
}

window.cleanOrderObject = function(orderObject)
{
	let newOrderObject = JSON.parse(JSON.stringify(orderObject));

	if(newOrderObject.detalle != null)
	{
		for(let i in newOrderObject.detalle)
		{
			let orderItem = newOrderObject.detalle[i];
			if(typeof orderItem.registrado != "undefined")
			{
				delete orderItem.registrado;
			}
			if(typeof orderItem.posicion != "undefined")
			{
				delete orderItem.posicion;
			}
			if(typeof orderItem.numerada != "undefined")
			{
				delete orderItem.numerada;
			}
			if(typeof orderItem.idTipoPrecio != "undefined")
			{
				delete orderItem.idTipoPrecio;
			}
		}
	}

	if(newOrderObject.pago != null)
	{
		for(let i in newOrderObject.pago)
		{
			let payment = newOrderObject.pago[i];
			if(typeof payment.registrado != "undefined")
			{
				delete payment.registrado;
			}
			if(typeof payment.importePendienteTransaccion != "undefined")
			{
				delete payment.importePendienteTransaccion;
			}
			if(typeof payment.fecha != "undefined")
			{
				delete payment.fecha;
			}
		}
	}

	return newOrderObject;
}

/**
 * Customers RelationShips
 */
window.CustomerRelationships =
{
	"SUPERVISOR": 1,
	"SUBORDINATE": 2,
};

window.BuyerTypes =
{
	"NOMINAL": 1,
	"NON_NOMINAL": 2,
}

window.CancellationTypes =
{
	'Transferred': -1,
    'Custom': 1,
    'Date_Change': 2,
    'Box_Office_Error': 3,
    'Seat_Change': 4,
    'User_Error': 5,
    'Ticket_Regeneration': 6,
    'Refund_Request': 7,
    'Insurance_Refund': 8,
    'Price_Change': 9
}

window.DataTypesIcaa = {
    "Cinema": 1,
    "Session": 2,
    "Hall": 3,
    "Price": 4,
    "Sale": 5,
    "Movie": 6
}

window.IdCardValidationResultStatus = {
	"VALID": 1,
	"NOT_VALID": 0,
	"IN_VALIDATION": -1
}
;
